import { create } from "zustand"

const initialState = {
    slug: null
}

const useSidebarStore = create((set, get) => ({
    ...initialState,
    setState: (nextState) => set(() => ({ ...nextState })),
    getState: () => get(),

}))

export default useSidebarStore